<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de procedimentos">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/relatorio-procedimento/List'

export default {
    components: { List },
}
</script>